import { useState, useEffect, useCallback } from 'react';
import { authHelper } from './authHelper';

export function useSubscription(user) {
  const [subscriptionStatus, setSubscriptionStatus] = useState({
    hasAccess: true,
    status: 'checking', // checking, active, trial, expired, free_access
    daysLeft: 0,
    isLoading: true
  });

  const checkSubscription = useCallback(async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/subscription-status`,
        {
          headers: authHelper.getAuthHeaders()
        }
      );

      if (response.ok) {
        const data = await response.json();
        setSubscriptionStatus({
          hasAccess: data.has_access,
          status: data.status,
          daysLeft: data.days_left || 0,
          isLoading: false
        });
      } else {
        // Default to no access if error
        setSubscriptionStatus({
          hasAccess: false,
          status: 'expired',
          daysLeft: 0,
          isLoading: false
        });
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
      setSubscriptionStatus({
        hasAccess: false,
        status: 'expired',
        daysLeft: 0,
        isLoading: false
      });
    }
  }, []);

  useEffect(() => {
    if (!user) {
      setSubscriptionStatus({
        hasAccess: false,
        status: 'expired',
        daysLeft: 0,
        isLoading: false
      });
      return;
    }

    checkSubscription();
  }, [user, checkSubscription]);

  return subscriptionStatus;
}
